import Script from 'next/script'
import { useRouter } from 'next/router'

import { getEnvVar } from '@mc/client-env'

const ProfitWell = () => {
  const { query } = useRouter()
  const PROFITWELL_BRAINTREE_TOKEN = getEnvVar('PROFITWELL_BRAINTREE_TOKEN')
  const PROFITWELL_STRIPE_TOKEN = getEnvVar('PROFITWELL_STRIPE_TOKEN')
  const PROFITWELL_ENABLED = getEnvVar('PROFITWELL_ENABLED')
  const PROFITWELL_BRAINTREE_ENABLED = getEnvVar('PROFITWELL_BRAINTREE_ENABLED')

  if (!PROFITWELL_BRAINTREE_TOKEN && !PROFITWELL_STRIPE_TOKEN) return <></>
  if (!PROFITWELL_ENABLED) return <></>

  const getInstanceToken = () => {
    const profitwellInstance = query?.pw_instance
    return profitwellInstance === 'b'
      ? PROFITWELL_BRAINTREE_TOKEN
      : PROFITWELL_STRIPE_TOKEN
  }
  const authToken = getInstanceToken()
  const isBraintreeInstance = authToken === PROFITWELL_BRAINTREE_TOKEN

  // If the visitor is coming from a Profitwell Braintree email but we have disabled it they
  // should see no modal. Visitors coming from a Stripe Profitwell email will
  // still get the Profitwell experience
  if (isBraintreeInstance && !PROFITWELL_BRAINTREE_ENABLED) return <></>

  return (
    <Script
      id='profitwell-js'
      data-pw-auth={authToken}
      dangerouslySetInnerHTML={{
        __html: `
          (function(i,s,o,g,r,a,m){i[o]=i[o]||function(){(i[o].q=i[o].q||[]).push(arguments)};
          a=s.createElement(g);m=s.getElementsByTagName(g)[0];a.async=1;a.src=r+'?auth='+
          s.getElementById(o+'-js').getAttribute('data-pw-auth');m.parentNode.insertBefore(a,m);
          })(window,document,'profitwell','script','https://public.profitwell.com/js/profitwell.js');
        `,
      }}
    />
  )
}

export default ProfitWell
